@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../../respond-to.scss';
@import '../../../global-styles/index.scss';

.ciHeader {
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: column;

  // This CSS is just for SB apps, otherwise the button looks funny due to missing font.
  .ghf-text-button, .ghf-primary-button, .ghf-secondary-button {
    font-family: SharpSans, Sharp Sans, Helvetica, Arial, "Trebuchet MS", sans-serif;
  }

  &-banner {
    background-color: $color-red-default;
    z-index: 980;

    &-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 $spacing-16;
      gap: $spacing-16;
      height: $spacing-32;
      background-color: $color-red-default;
      font-size: $typography-caption-caption-regular-size;
      color: $color-shade-white;
      justify-content: space-between;
      box-sizing: content-box;
    }

    &-title {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    &-actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding: 0;
      gap: $spacing-16;
      height: 100%;
      margin-right: -16px;
    }

    &-title--desktop {
      display: none;
    }
  }

  &-main {
    display: flex;
    border-bottom: 1px solid $color-gray-accent;
    background-color: $color-shade-white;
    height: $spacing-48;
    &--withSearch {
      @extend .ciHeader-main;
    }
    &-wrapper {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      height: 100%;
      width: 100%;
      box-sizing: content-box;
    }

    &-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 40px;
    }
  }
  &-accounts {
    display: block;
    position: relative;
    .ghf-text-button {
      font-size: 12px !important;
      padding: 0 8px;
      height: 40px;
      &:link, &:visited {
        color: $color-gray-slate-default;
      }
      &:hover {
        color: $color-blue-default;
        svg, path {
          fill: $color-blue-default;
        }
      }
    }
    &-btn {
      // must be above the z-index of 100, set for the .ciHeader-account-subMenu element in ci-accounts.scss
      z-index: 101;
      position: relative;
      line-height: 1.333;
      white-space: nowrap;
      &--isActive {
        color: $color-blue-default;
        background: $color-header-hover-blue;
        &:link, &:visited {
          color: $color-blue-default;
        }
        svg, path {
          fill: $color-blue-default;
        }
      }
    }
  }

  &-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 900;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    visibility: hidden;
    opacity: 0;
    transition: all 0.15s ease-out;

    &.active {
      visibility: visible;
      opacity: 1;
    }
  }

  &-subNav {
    display: flex;
    flex-direction: row;
    &-wrapper {
      display: none;
      flex-direction: row;
      align-items: center;
      padding: 0;
      height: 100%;
      &:hover {
        .ciHeader {
          &-subNav-window,
          &-overlay {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
    &-item {
      display: flex;
      align-self: stretch;
      justify-content: stretch;
      text-decoration: none;
      color: $color-gray-slate-default;
      &:link, &:visited {
        color: $color-gray-slate-default;
      }
      &:hover {
        .ciHeader-subNav-text {
          background: $color-header-hover-blue;
          color: $color-blue-default;
        }
      }
      &:focus {
        outline: none;
        .ciHeader-subNav-text {
          border-radius: 4px;
          border: 1px solid $color-blue-default;
        }
      }
    }

    &-link {
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      color: $color-gray-slate-default;
      &:link, &:visited {
        color: $color-gray-slate-default;
      }
    }

    &-text {
      display: inline-block;
      font-size: $typography-button-large-size;
      line-height: $typography-line-height;
      padding: 0.6rem;
      border-radius: 6px;
      text-decoration: none;
      white-space: nowrap;
    }

    &-window {
      display: block;
      visibility: hidden;
      opacity: 0;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      position: absolute;
      top: 108px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 976px;
      height: 374px;
      z-index: 920;
    }

    // subNav :hover mechanics

    #productLink:hover {
      #productOverlay {
        display: block;
      }
    }
    #designLink:hover {
      #designOverlay {
        display: block;
      }
    }
    #templatesLink:hover {
      #templatesOverlay {
        display: block;
      }
    }
    #solutionsLink:hover {
      #solutionsOverlay {
        display: block;
      }
    }
  }

  &-mobile-menu-btn {
    cursor: pointer;
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 14px 11px;
    margin-left: -8px;
    margin-right: 4px;

    span {
      background: black;
      border-radius: 3px;
      content: '';
      width: 18px;
      height: 2px;
    }
  }

  &-logo {
    &-image {
      height: 40px;
      display: block;
    }
  }
}

.tertiary-secondary-button {
  border: 1px solid $color-primary-default;
  border-radius: 6px;
  width: 100%;
  height: 44px;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: $color-primary-default;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}

@include breakpoint('lg') {
  #productOverlay,
  #designOverlay,
  #templatesOverlay,
  #solutionsOverlay {
    display: none;
    position: absolute;
    background-color: $color-shade-white;
    z-index: 930;
    top: 108px;
    width: 976px;
    height: 374px;
    left: 50%;
    transform: translateX(-50%);
  }

  .ciHeader {
    &-banner {
      &-wrapper {
        padding: 0 24px;
        max-width: 978px;
        margin: auto;
      }

      &-title {
        &--desktop {
          display: inline;
        }
      }

      &-actions {
        margin: 0;
      }

      &-title--mobile {
        display: none;
      }
    }

    &-main {
      height: 80px;
      z-index: 910;

      &-wrapper {
        align-items: center;
        max-width: 976px;
        margin: auto;
        justify-content: space-between;
        padding: 0 $spacing-16;
      }

      &-image {
        &--mobile {
          display: none;
        }

        &--desktop {
          display: block;
          height: 50px;
        }
      }
    }

    &-logo-image {
      height: 40px;
    }

    &-subNav {
      gap: $spacing-16;
      display: flex;
      flex-direction: row;
      align-items: center;

      &-wrapper {
        display: flex;
      }
      &-text {
        padding: 8px 12px;
      }
    }

    &-main-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: -8px;
    }

    &-hamburger-button,
    &-products-menu,
    &-mobile-menu-btn,
    &-mobile-nav {
      display: none;
    }
  }
}

@include breakpoint('xl') {
  #productOverlay,
  #designOverlay,
  #templatesOverlay,
  #solutionsOverlay {
    display: none;
    position: absolute;
    background-color: $color-shade-white;
    z-index: 930;
    top: 108px;
    width: 1252px;
    height: 374px;
    left: 50%;
    transform: translateX(-50%);
  }

  .ciHeader {
    margin: auto;

    &-banner {
      &-wrapper {
        padding: 0 24px;
        max-width: 1252px;
        margin: auto;
      }

      &-title {
        &--desktop {
          display: inline;
        }
      }

      &-actions {
        margin: 0;
      }

      &-actions--desktop {
        display: flex;
        min-width: 526px;
      }

      &-title--mobile,
      &-actions--mobile {
        display: none;
      }
    }

    &-main {
      height: 80px;
      z-index: 910;

      &-wrapper {
        align-items: center;
        max-width: 1252px;
        margin: auto;
        justify-content: space-between;
        padding: 0 $spacing-16;
      }

      &-image {
        &--mobile {
          display: none;
        }

        &--desktop {
          display: block;
          height: 50px;
        }
      }
    }

    &-logo-image {
      height: 54px;
    }

    &-subNav {
      gap: $spacing-16;
      height: 80px;
      display: flex;
      flex-direction: row;
      align-items: center;

      &-wrapper {
        display: flex;
      }

      &-window {
        width: 1252px;
      }
      &-text {
        padding: 8px 16px;
      }
    }

    &-main-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: -8px;
    }

    &-hamburger-button,
    &-products-menu,
    &-mobile-menu-btn,
    &-mobile-nav {
      display: none;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .ciHeader-subNav {
    height: 100%;
  }
}
@media only screen and (max-width: 1023px) {
  .ciHeader-main {
    height: 65px;
  }
  .ciHeader-main-wrapper {
    padding: 0 $spacing-16;
  }
}

@media only screen and (max-width: 674px) {
  .ciHeader-main {
    &--withSearch {
      @extend .ciHeader-main;
      height: 118px;

      .ciHeader-main-wrapper {
        height: 55%;
      }
    }
  }
}
